import React, { useCallback, useMemo, useState } from 'react';
import { debounce, TextField } from '@mui/material';
import BaseQuestionProps from 'pages/Activities/ActivityAssignmentStep/StepQuestion/BaseQuestionProps';

type Props = BaseQuestionProps<string>;

const TextQuestion = ({ value, onChange, readOnly }: Props) => {
  const [currentValue, setCurrentValue] = useState(value);

  const saveTextChange = useCallback(
    (newValue: string) => {
      onChange && onChange(newValue);
    },
    [onChange]
  );

  const debouncedTextChange = useMemo(() => debounce(saveTextChange, 1000), [saveTextChange]);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      const newValue = event.target.value;
      debouncedTextChange(newValue);
      setCurrentValue(newValue);
    },
    [debouncedTextChange]
  );

  return (
    <TextField
      multiline={true}
      minRows={7}
      placeholder='Answer here'
      value={currentValue || ''}
      onChange={handleChange}
      style={{ width: 450 }}
      InputProps={{
        readOnly,
      }}
    />
  );
};

export default TextQuestion;
